import { Grid } from '@mui/material';
import * as React from 'react';
import {
  cursa,
  cursoflix,
  gemini,
  learning,
  quizzy,
} from '../../helpers/ImagesUtils';
import CardHerramientas from './components/CardHerramientas';

const HerramientasView = () => {
  const lista = [
    {
      id: 1,
      img: learning,
      title: 'Learning Studio AI',
      desc: 'Plataforma de creacion de aprendizaje dinámica',
      url: 'https://learningstudioai.com',
    },
    {
      id: 2,
      img: quizzy,
      title: 'QUIZIZZ',
      desc: 'Plataforma de aprendizaje y evaluación en línea',
      url: 'https://quizizz.com',
    },
    {
      id: 3,
      img: gemini,
      title: 'GEMINI AI',
      desc: 'Inteligencia artificial para la educación',
      url: 'https://gemini.google.com/app',
    },
    {
      id: 4,
      img: cursoflix,
      title: 'CURSOS FLIX',
      desc: 'Realiza cursos gratis desde cualquier lugar',
      url: 'https://claseflix.com/',
    },
    {
      id: 5,
      img: cursa,
      title: 'CURSOS CON CERTIFICADO',
      desc: 'Realiza ccursos con certificado y gratis',
      url: 'https://cursa.app/es',
    },
  ];

  return (
    <Grid container spacing={1}>
      {lista.map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item.id}>
          <CardHerramientas
            img={item.img}
            title={item.title}
            desc={item.desc}
            url={item.url}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default HerramientasView;
